export const ActionTypes = {
// Screen- Release Component Management
// Lazy Loading parameters for MRT Table actions
SET_FILTER_PAGE : 'SET_FILTER_PAGE',
SET_SEARCH : 'SET_SEARCH',
SET_SORT : 'SET_SORT',
FETCH_GRID_API_REQUEST: 'FETCH_API_REQUEST',
FETCH_GRID_API_SUCCESS:'FETCH_API_SUCCESS',
FETCH_GRID_API_FAILURE: 'FETCH_API_FAILURE',
FETCH_REPORT_GRID_API_REQUEST:'FETCH_REPORT_GRID_API_REQUEST',
FETCH_REPORT_GRID_API_SUCCESS:'FETCH_REPORT_GRID_API_SUCCESS',
FETCH_REPORT_GRID_API_FAILURE:'FETCH_REPORT_GRID_API_FAILURE',
SET_INFORMATION_ALERT_TEXT:'SET_INFORMATION_ALERT_TEXT',

 // Release Component Management Details Data Grid API call actions
 FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_REQUEST: 'FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_REQUEST',
 FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST: 'FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST',
 FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_FAILURE:'FETCH_RELEASE_MANAGEMENT_COMPONENT_DETAILS_FAILURE',
 RESET_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST: 'RESET_RELEASE_MANAGEMENT_COMPONENT_DETAILS_DATALIST',
 SET_REJECTION_REASON: 'SET_REJECTION_REASON',
 SET_APPROVED_REJECT:'SET_APPROVED_REJECT',
 FETCH_RELEASE_NOTES_DOWNLOAD_REQUEST:'FETCH_RELEASE_NOTES_DOWNLOAD_REQUEST',
 FETCH_RELEASE_NOTES_DOWNLOAD:'FETCH_RELEASE_NOTES_DOWNLOAD',
 SET_INFORMATION_ALERT:'SET_INFORMATION_ALERT',
 FETCH_NETWORK_DIAGRAM:'FETCH_NETWORK_DIAGRAM',
 SET_ROW_DETAILS:'SET_ROW_DETAILS',
 
// APPROVAL STATUS SELECTED actions
SET_APPROVAL_STATUS : 'SET_APPROVAL_STATUS',

// Screen- User Management
// open and close Add a colleague drawer
SET_ADD_COLLEAGUE_DRAWER_OPEN : 'SET_ADD_COLLEAGUE_DRAWER_OPEN',
SET_EDIT_COLLEAGUE_DRAWER_OPEN : 'SET_EDIT__COLLEAGUE_DRAWER_OPEN',
ADD_COLLEAGUE_REQUEST:'ADD_COLLEAGUE_REQUEST',
UPDATE_COLLEAGUE_REQUEST:'UPDATE_COLLEAGUE_REQUEST',
POST_UPDATE_COLLEAGUE_SUCCESS:'POST_UPDATE_COLLEAGUE_SUCCESS',
POST_ADD_COLLEAGUE_SUCCESS:'POST_ADD_COLLEAGUE_SUCCESS',
POST_ADD_COLLEAGUE_FAILURE:'POST_ADD_COLLEAGUE_FAILURE',
SET_USER_DETAILS_PARAMETERS:'SET_USER_DETAILS_PARAMETERS',
SET_PAGE_INDEX:'SET_PAGE_INDEX',

// open and close confirmation alert after click of cancel or close button of confimation box
SET_CONFIRMATION_ALERT: 'SET_CONFIRMATION_ALERT',
SET_CONFIRMATION_ACTION: 'SET_CONFIRMATION_ACTION',
RESET_CONFIRMATION_ACTION: 'RESET_CONFIRMATION_ACTION',

// Add colleague modal formData actions
SET_COLLEAGUE_FORMDATA: 'SET_COLLEAGUE_FORMDATA',
RESET_COLLEAGUE_FORMDATA: 'RESET_COLLEAGUE_FORMDATA',
STATUS_TOASTMESSAGE: 'STATUS_TOASTMESSAGE',
CLOSE_STATUS_TOASTMESSAGE: 'CLOSE_STATUS_TOASTMESSAGE',
USER_UPDATE_TOASTMESSAGE:'USER_UPDATE_TOASTMESSAGE',
TOGGLE_USER_ACTIVE_STATUS:'TOGGLE_USER_ACTIVE_STATUS',

// Default Edit form entries
SET_EDITFORM_DEFAULT_ENTRIES: 'SET_EDITFORM_DEFAULT_ENTRIES',
RESET_EDITFORM_DEFAULT_ENTRIES: 'RESET_EDITFORM_DEFAULT_ENTRIES',
SET_FORMFIELD_ERRORS: 'SET_FORMFIELD_ERRORS',
RESET_FORMFIELD_ERRORS:'RESET_FORMFIELD_ERRORS',

//Screen - Reports
// Filter selection for report creation
SET_SITELIST: "SET_SITELIST",
SET_REPORT_FILTER_DRAWER_OPEN: 'SET_REPORT_FILTER_DRAWER_OPEN',
SET_FILTER_CREATE_REPORT_FORMDATA : 'SET_FILTER_CREATE_REPORT_FORMDATA',
RESET_FILTER_CREATE_REPORT_FORMDATA: 'RESET_FILTER_CREATE_REPORT_FORMDATA',
FETCH_CREATE_REPORT_SUMMARY_REQUEST: 'FETCH_CREATE_REPORT_SUMMARY_REQUEST',
FETCH_CREATE_REPORT_SUMMARY_DATA: 'FETCH_CREATE_REPORT_SUMMARY_DATA',
GET_REPORT_SUMMARY_DATA: "GET_REPORT_SUMMARY_DATA",
GET_DEFAULT_REPORT_SUMMARY_DATA: "GET_DEFAULT_REPORT_SUMMARY_DATA",
FETCH_CREATE_REPORT_SUMMARY_FAILURE: 'FETCH_CREATE_REPORT_SUMMARY_FAILURE',
DISABLE_LOADING:'DISABLE_LOADING',
SET_REPORT_DETAILS_PARAMETERS:'SET_REPORT_DETAILS_PARAMETERS',
RESET_REPORT_PARAMETERS:'RESET_REPORT_PARAMETERS',

// Screen- Audit-log
// Audit-log type selection to fetch corresponding table columns and rows
SET_AUDIT_TYPE_SELECTION : "SET_AUDIT_TYPE_SELECTION",
RESET_AUDIT_GRID_DATE: "RESET_AUDIT_GRID_DATE",

// DateRange Filter
SET_SELECTED_DATERANGE: "SET_SELECTED_DATERANGE",

//Auth0 Parameters
SET_AUTHORIZATION_USERINFO: "SET_AUTHORIZATION_USERINFO",
SET_NAVIGATION_DRAWER_STATE: "SET_NAVIGATION_DRAWER_STATE",
SET_PORTAL_LOGOUT:"SET_PORTAL_LOGOUT",
SET_USER_ROLES: "SET_USER_ROLES",
SET_USER_PERMISSIONS: "SET_USER_PERMISSIONS",
}